import "@/App.css";
import "@/lib/theme"; // initialize theme (light/dark/system) before first render
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardLayout from "@/pages/DashboardLayout";
import DashboardHome from "@/pages/DashboardHome";
import CalendarPage from "@/pages/CalendarPage";
import StudentsPage from "@/pages/StudentsPage";
import TeachersPage from "@/pages/TeachersPage";
import StudentDetailPage from "@/pages/StudentDetailPage";
import AccountingPage from "@/pages/AccountingPage";
import ReportsPage from "@/pages/ReportsPage";
import SettingsPage from "@/pages/SettingsPage";
import AdminPage from "@/pages/AdminPage";
import SubscriptionGate from "@/components/SubscriptionGate";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-muted-foreground">Yükleniyor…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/giris" replace />;
  return children;
}

function RootGate({ children }) {
  // At "/" — show landing page when logged out, dashboard layout when logged in.
  // For any deeper route under the DashboardLayout tree, fall back to the login redirect.
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-muted-foreground">Yükleniyor…</div>
      </div>
    );
  }
  if (user) return children;
  if (location.pathname === "/") return <LandingPage />;
  return <Navigate to="/giris" replace />;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/giris" element={<PublicOnly><LoginPage /></PublicOnly>} />
            <Route path="/kayit" element={<PublicOnly><RegisterPage /></PublicOnly>} />
            <Route path="/" element={<RootGate><DashboardLayout /></RootGate>}>
              <Route index element={<DashboardHome />} />
              <Route path="takvim" element={<CalendarPage />} />
              <Route path="ogrenciler" element={<StudentsPage />} />
              <Route path="ogrenciler/:id" element={<StudentDetailPage />} />
              <Route path="ogretmenler" element={<TeachersPage />} />
              <Route path="muhasebe" element={<AccountingPage />} />
              <Route path="raporlar" element={<ReportsPage />} />
              <Route path="ayarlar" element={<SettingsPage />} />
              <Route path="admin" element={<AdminPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <SubscriptionGate />
      </AuthProvider>
    </div>
  );
}
